export enum APIURLTypes {
    IAM = 1,
    DCM = 2,
    SCM = 3,
    REACTIVE = 4
}

